import React, { Component } from 'react';
import { userStatus, envConfig, store } from '../../../_helpers';
import { Loader } from '../../../_components';
import { Pie } from 'react-chartjs-2';
import queryString from 'query-string';
import { history } from '../../../_helpers';
import moment from 'moment';

export default class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: this.props.parentDomain,
      labels: [],
      values: [],
      table_values: [],
      loaded: false,
      period: this.props.period,
      start: this.props.period.start,
      end: this.props.period.end,
    }
  }

  async componentDidMount() {
    if ( this.state.domain ) {
      this.listAnalyticsData(this.state.domain, this.state.start, this.state.end);
    }
  }

  async componentWillReceiveProps(nextProps) {
    if ( nextProps.period.start === this.state.start && nextProps.period.end === this.state.end ) return;

    await this.setState({
      loaded: false,
      table_values: [],
      values: [],
      labels: [],
      start: nextProps.period.start,
      end: nextProps.period.end,
      domain: queryString.parse(history.location.search).domain
    }, () => this.listAnalyticsData(this.state.domain, nextProps.period.start, nextProps.period.end));
  }

  async listAnalyticsData(domain, start, end) {
    const user = userStatus();
    let { endpoint } = this.state;

    if ( !domain ) domain = this.state.domain;
    if ( !start ) start = this.state.start;
    if ( !end ) end = this.state.end;

    let url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    let options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${user.bearer_token}`
      }
    }

    let request = await fetch(url, options);

    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }
    let response = await request.json();
    if ( response.data.length === 0 ) response.data = 0;
    if ( response.message === 'Most viewed pages have been loaded.' ) return this.setState({table_values: response.data});
    
    let labels = [];
    let values = [];

    if ( !Array.isArray(response.data) ) {
      return this.setState({
        labels: Object.keys(response.data),
        values: Object.keys(response.data).map(function (key) { return response.data[key]; }),
        table_values: response.data
      });
    }

    response.data.map(data => {
      labels.push(data.url);
      values.push(data.count);
    });

    this.setState({labels: labels, values: values, loaded: true, table_values: response.data});
  }

  render() {
    let data = {
      labels: this.state.labels,
      datasets: [{
          label: 'Páginas mais visitadas',
          data: this.state.values,
          backgroundColor: [
              'rgb(255, 224, 230)',
              'rgb(214, 236, 251)',
              'rgb(218, 250, 213)',
              'rgb(254, 255, 224)'
          ],
          fill: false,
          borderWidth: 0
      }],
      options: {
        plugins: { datalabels: { display: false }},
        responsive: true,
      }
    }

    return (
      <div key={this.props.title} className={`col-xs-12 col-sm-12 col-md-${this.props.colsize} col-lg-${this.props.colsize}`}>
        <div className="card">
          <p className="title title-outside">{this.props.title}</p>

          {
            this.state.table_values.length !== 0 ||
            this.state.labels.length !== 0 && this.state.values.length !== 0 ?
              this.props.type === 'pie' ?
                <Pie data={data} options={data.options}/>
            : null : null
          }

          {
            this.state.table_values.length !== 0 ||
            this.state.labels.length !== 0 && this.state.values.length !== 0 ?
              this.props.type === 'visits' ?
                <div className="table-responsive table-responsive-height">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>URL</th>
                        <th>Mobile</th>
                        <th>Desktop</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.table_values.length > 0 ?
                          this.state.table_values.map(data => {
                            return <tr>
                              <td>{data.url}</td>
                              <td>{data.mobile}</td>
                              <td>{data.desktop}</td>
                              <td>{data.count}</td>
                            </tr>
                          })
                        : null
                      }
                    </tbody>
                  </table>
                </div>
            : null : <Loader className="is-blue" />
          }

          {
            this.state.table_values.length !== 0 ||
            this.state.labels.length !== 0 && this.state.values.length !== 0 ?
              this.props.type === 'momentums' ?
                <div className="table-responsive table-responsive-height">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Momentum</th>
                        <th>Data</th>
                        <th>Enviados</th>
                        <th>Visualizados</th>
                        <th>Cliques</th>
                        <th>CTR</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.table_values.length > 0 ?
                          this.state.table_values.map(data => {
                            return <tr>
                              <td>{data.momentum_title}</td>
                              <td>{moment(data.date).format('DD/MM/YYYY')}</td>
                              <td>{data.notifications_sent}</td>
                              <td>{data.notifications_viewed}</td>
                              <td>{data.notifications_clicked}</td>
                              <td>{data.notifications_ctr}</td>
                            </tr>
                          })
                        : null
                      }
                    </tbody>
                  </table>
                </div>
            : null : null
          }

          {
            this.state.table_values.length !== 0 ||
            this.state.labels.length !== 0 && this.state.values.length !== 0 ?
              this.props.type === 'channels' ?
                <div className="table-responsive table-responsive-height">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Canal</th>
                        <th>Base Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.labels.length > 0 ?
                          this.state.labels.map((data, index) => {
                            return <tr>
                              <input type="hidden" name="datatocsv" value={`${(this.props.title.includes("Visitantes")) ? "Visitas" : "Base do canal de "} ${data}: ${this.state.values[index]}`}/>
                              <td>{data}</td>
                              <td>{this.state.values[index]}</td>
                            </tr>
                          })
                        : null
                      }
                    </tbody>
                  </table>
                </div>
            : null : null
          }
        </div>
      </div>
    )
  }
}